module.exports = __webpack_public_path__ + "img/vm1-mini.4e2636be.jpg";